import React, { useEffect, useState } from 'react';
import SecondaryHeaderItems from '../Presentation/SecondaryHeaderItems';
import { isMobileDevice } from 'common/utilities/utils';
import { withRouter } from 'react-router-dom';
/**
 * Main Container for Entire Header Components
 * @param - json data from content side
 */

const SecondaryHeader = props => {
  const { contentData = {}, history } = props;
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));

  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  /**
   * Use to add window listner for windown size change
   */
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const onNavigateToHome = () => {
    history.push({
      pathname: '/',
    });
  };

  return (
    <div className={`${isMobile ? 'mobile header' : 'desktop header'}`} data-testid='HeaderItems-component'>
      <SecondaryHeaderItems
        contentData={contentData}
        isMobile={isMobile}
        // clickHandler={onHeaderItemSelect}
        navigateHandler={onNavigateToHome}
        {...props}
      />
    </div>
  );
};

export default withRouter(SecondaryHeader);
